import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import AdminUser from "./AdminUser";
import '../../css/adminStyling.css';
import AdminAddUser from "./AdminAddUser";
import { useAdminUsers } from "../../utils/adminUsers";
import { useAdminActiviteiten } from "../../utils/adminActiviteiten";


const AdminAppUsers = () => {

    const usr = useAdminUsers();
    const act = useAdminActiviteiten();
    const users = usr.adminUsers;
    const takenVrijwilligers = act.adminTakenVrijwilligers;


    const [usersAndTaken, setUsersAndTaken] = useState([]);

    const usersTaken = () => {
        const userArray = [];
        users && users.forEach(element => {
            const userTaken = [];
            const gebruiker = element._id
            takenVrijwilligers.forEach(taak => {

                if (taak.vrijwilliger == gebruiker ) {
                    const taakX = {
                        activiteitID: taak.activiteitID,
                        activiteitDatum: taak.activiteitDatum,
                        activiteitNaam: taak.activiteitNaam,
                        taakNaam: taak.taakNaam,
                        taakBevestigd: taak.Bevestigd,
                        taakVoltooid: taak.taakVoltooid
                    }
                    userTaken.push(taakX);
                }
            });
            const userX = {
                ...element,
                taken: userTaken
            }
            userArray.push(userX);
            setUsersAndTaken(userArray);
        });
    }

    useEffect(() => {
        usersTaken();
    }, [users]);

    

    const loadingData = () => {
        usr.loadAdminUsers();
    };

    const [addUser, setAddUser] = useState(false);

    const updateUserList = () => {
        usr.loadAdminUsers();
    }

    const showAddUser = () => {
        setAddUser(true);
    }

    const closeShowAddUser = () => {
        setAddUser(false);
    }

    useEffect(() => {
        loadingData();
    },[]);






    return (
        <>
            <div>
                <button onClick={showAddUser}>Gebruiker toevoegen</button>
                {addUser && <AdminAddUser 
                    closeShowAddUser={closeShowAddUser}
                    getUserData={updateUserList} 
                />}

            </div>
            <div className='userListSection'>
                <h3>Gebruikers:</h3>
                <p>{usr.loadingMessage}</p>
                <div>
                    <div className='userListContainer'>
                        <div className='userContainerHeader'>
                            <p>Naam</p>
                            <p>Gebruikersnaam</p>
                        </div>

                        {usersAndTaken && usersAndTaken.map(user => <AdminUser user={user} key={user._id} updateUserList={updateUserList}/>)}
                    </div>
                </div>
            </div>

            <Outlet />
        </>
    );
}

export default AdminAppUsers;